import styled from 'styled-components'
import { Heading, theme } from '@notino/react-styleguide'

// styles
import { CONTAINER_X_PADDING, MY_RESERVATION_PAGE_MOBILE_BREAKPOINT } from '../../../../styles/constants'
import { NotinoLabelLarge, NotinoLabelRegular400, NotinoLabelRegular500, NotinoLabelSmall400 } from '../../../../styles/helpers'

export const ReservationContainer = styled.div``

export const StatusBadgeWrapper = styled.div`
	margin-bottom: 10px;
`

export const TitleWrapper = styled.div`
	margin-bottom: 20px;
`

export const MainTitle = styled(Heading.H1)`
	font-weight: 500;
	margin-top: 0;
	margin-bottom: 0;
	text-align: left !important; // override for notino global styles
`

export const Description = styled.p`
	${NotinoLabelRegular400};
	white-space: pre-wrap;
	color: ${theme.color.text.secondary};
	margin-bottom: 0;
	margin-top: 4px;
`

export const SalonInfoContainer = styled.div`
	margin-bottom: 20px;
`

export const CtaButtonsContainer = styled.div`
	margin-left: -${CONTAINER_X_PADDING}px;
	margin-right: -${CONTAINER_X_PADDING}px;
	padding-left: ${CONTAINER_X_PADDING}px;
	padding-right: ${CONTAINER_X_PADDING}px;
	overflow-x: auto;
	justify-content: space-between;
	display: flex;
	gap: 10px;
	margin-bottom: 40px;

	@media (min-width: ${MY_RESERVATION_PAGE_MOBILE_BREAKPOINT}) {
		margin-left: 0;
		margin-right: 0;
		padding-left: 0;
		padding-right: 0;
		overflow-x: hidden;
		flex-wrap: wrap;
	}
`

export const LeftCtaButtonsContainer = styled.div`
	display: flex;
	gap: 10px;

	@media (min-width: ${MY_RESERVATION_PAGE_MOBILE_BREAKPOINT}) {
		flex-wrap: wrap;
	}
`

export const RightCtaButtonsContainer = styled.div`
	display: flex;
	gap: 10px;

	@media (min-width: ${MY_RESERVATION_PAGE_MOBILE_BREAKPOINT}) {
		flex-wrap: wrap;
	}
`

export const InfoList = styled.ul``

export const InfoListItem = styled.li`
	display: flex;
	gap: 10px;

	&:not(:last-child) {
		padding-bottom: 16px;
		margin-bottom: 16px;
		border-bottom: 1px solid ${theme.color.border.divider};
	}
`

export const InfoItemIconContainer = styled.div`
	flex-shrink: 0;

	svg {
		width: 1.25rem;
		height: 1.25rem;
		color: ${theme.color.icon.primary};
	}
`

export const InfoItemContent = styled.div`
	flex: 1;
`

export const InfoItemTitle = styled.div`
	${NotinoLabelSmall400};
	margin-bottom: 4px;
`

export const InfoItemText = styled.span`
	${NotinoLabelLarge};
	word-break: break-word;
	white-space: pre-wrap;
`

export const InfoContentServiceLayout = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 16px;
`

export const InfoContentService = styled.div``

export const InfoContentServicePrice = styled.span`
	${NotinoLabelLarge};
	white-space: nowrap;
`

export const CustomerInfo = styled.span`
	${NotinoLabelSmall400};
	color: ${theme.color.text.secondary};
	display: flex;
	flex-direction: column;
	gap: 4px;
	word-break: break-word;
`

export const CustomerName = styled.span`
	${NotinoLabelRegular500};
	color: ${theme.color.text.primary};
	word-break: break-word;
`

export const CustomerInfoText = styled.span`
	word-break: break-word;
`

export const VisitorInfoMessage = styled.div`
	${NotinoLabelRegular400};
	background-color: ${theme.color.background.tertiary};
	display: flex;
	gap: 8px;
	align-items: center;
	margin-top: 10px;
	padding: 12px;

	svg {
		width: 20px;
		height: 20px;
		flex-shrink: 0;
		color: ${theme.color.icon.tertiary};
	}
`
